import { DOMHelper } from '../../Helpers/DOMHelper.js';
import { PmDatalayer } from "../../Datalayer/PmDatalayer.js";

/**
 * for common features between forms
 * like setting values for hiden fields like vin, lead id, site token
 */
export class PmDrsForms {

	/**
	 * [constructor description]
	 * @param  {[type]} type Finance, lease
	 * @return {[type]}      [description]
	 */
	constructor(app){
		this.app = app;		
	}

	init() {
		this.setHiddenFieldsValues();
		this.setLeadIdValues();
	}

	/**
	 * Set values for hidden fields
	 */
	setHiddenFieldsValues(){
		var pmdrsForms = this;
		let keyValues = {
			st: pmdrsForms.app.pmdrs.config.accountId,
			vin: pmdrsForms.app.config.vehicle.vin			
		}

		for (const [key, value] of Object.entries(keyValues) ) {
			let selector = pmdrsForms.app.getSelector(".pmdrs-hidden-field[name="+key+"]");
			DOMHelper.setValue(selector, value);
		}		
	}

	

	setLeadIdValues(){
		var pmdrsForms = this;
		let selector = pmdrsForms.app.getSelector(".pmdrs-hidden-field[name=leadId]");
		DOMHelper.querySelectorAction(selector, (item) => {
			item.value = pmdrsForms.app.generateLeadId();
		});
	}	

    /**
     * created to complete lead id with 11 random chars
     * @param  int length [description]
     * @return string
     */
    getRandomHexString(length) {
        var randomChars = 'abcdef0123456789';
        var result = '';
        for ( var i = 0; i < length; i++ ) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    }

	stellantisHashEmail(email){
		const shaHash = async (message) => {
			const msgUint8 = new TextEncoder().encode(message);
			const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
			const hashArray = Array.from(new Uint8Array(hashBuffer));
			const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
			return hashHex;
		};

		if(crypto.subtle){
			return shaHash(email);
		}
		
		return new Promise(function(resolve, reject){
			resolve(email);
		});
	}

}